import { useEffect, useRef, useState } from "react";
import { IExpenseVendor } from "../models/IExpenseVendor";
import { getExpenseVendors } from "../services/expenseVendor";

interface Props {
  onSelect: (vendor: IExpenseVendor | null) => void;
  onClose: () => void;
}

export default function VendorPicker({ onSelect, onClose }: Props) {
  const [vendors, setVendors] = useState<IExpenseVendor[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    getExpenseVendors(true)
      .then((res) => setVendors(res.data ?? []))
      .catch(() => setVendors([]))
      .finally(() => setLoading(false));
    setTimeout(() => inputRef.current?.focus(), 50);
  }, []);

  const q = search.trim().toLowerCase();
  const filtered = vendors.filter((v) =>
    !q || v.name.toLowerCase().includes(q) || v.note?.toLowerCase().includes(q)
  );

  return (
    <div style={{ position: "absolute", inset: 0, zIndex: 10, background: "#fff", display: "flex", flexDirection: "column", borderRadius: "inherit" }}>
      <div style={{ padding: "12px 16px", borderBottom: "1.5px solid #f1f5f9", display: "flex", alignItems: "center", gap: 10, flexShrink: 0, background: "#fafafa" }}>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280", fontSize: "1rem", padding: 0 }}>
          <i className="bi bi-arrow-left" />
        </button>
        <input
          ref={inputRef}
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Firma ara…"
          style={{ flex: 1, borderRadius: 9, border: "1.5px solid #fde68a", padding: "7px 12px", fontSize: "0.88rem", outline: "none", background: "#fffbeb", fontFamily: "inherit" }}
        />
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        <button
          onClick={() => onSelect(null)}
          style={{ width: "100%", textAlign: "left", border: "none", borderBottom: "1px solid #f1f5f9", background: "transparent", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}
        >
          <div style={{ width: 34, height: 34, borderRadius: 9, flexShrink: 0, background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af" }}>
            <i className="bi bi-slash-circle" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: "0.86rem", color: "#6b7280" }}>Firma seçilmedi</div>
          </div>
        </button>

        {loading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "32px 0" }}>
            <span className="spinner-border" style={{ color: "#b45309" }} />
          </div>
        )}
        {!loading && filtered.length === 0 && (
          <div style={{ textAlign: "center", padding: "32px 16px", color: "#9ca3af", fontSize: "0.84rem" }}>Firma bulunamadı</div>
        )}
        {filtered.map((v) => (
          <button
            key={v.id}
            onClick={() => onSelect(v)}
            style={{ width: "100%", textAlign: "left", border: "none", borderBottom: "1px solid #f1f5f9", background: "transparent", padding: "11px 16px", cursor: "pointer", display: "flex", alignItems: "center", gap: 10, opacity: v.isEnabled ? 1 : 0.6 }}
          >
            <div style={{ width: 34, height: 34, borderRadius: 9, flexShrink: 0, background: v.isEnabled ? "linear-gradient(135deg,#b45309,#d97706)" : "linear-gradient(135deg,#9ca3af,#6b7280)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <i className="bi bi-building text-white" style={{ fontSize: "0.82rem" }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: "0.86rem", color: "#111827", display: "flex", alignItems: "center", gap: 6 }}>
                {v.name}
                {!v.isEnabled && <span style={{ fontSize: "0.62rem", fontWeight: 700, color: "#9ca3af", border: "1px solid #e5e7eb", borderRadius: 6, padding: "1px 5px" }}>PASİF</span>}
              </div>
              {v.note && <div style={{ fontSize: "0.72rem", color: "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{v.note}</div>}
            </div>
            <i className="bi bi-chevron-right" style={{ color: "#d1d5db", fontSize: "0.7rem" }} />
          </button>
        ))}
      </div>
    </div>
  );
}
